/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faVideo,
  faDesktop,
  faVideoSlash,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import "./MeetingFooter.css";
import { ReactMediaRecorder } from "react-media-recorder";
import swal from "sweetalert";
const MeetingFooter = (props) => {
  const [streamState, setStreamState] = useState({
    mic: true,
    video: false,
    screen: false,
  });

  const callDecline = () => {
    swal({
      title: "Are you sure?",
      text: "You want to leave this call",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          if (localStorage.getItem('auth_type') == 'admin') {

            window.location.href = `/superstar-admin/live-chat/stream/${props.slug}`;
          } else {
            window.location.href = `/superstar/live-chat/stream/${props.slug}`;
          }



        }

      });
  }
  const micClick = () => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        mic: !currentState.mic,
      };
    });
  };

  const onVideoClick = () => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        video: !currentState.video,
      };
    });
  };

  const onScreenClick = () => {
    props.onScreenClick(setScreenState);
  };

  const setScreenState = (isEnabled) => {
    setStreamState((currentState) => {
      return {
        ...currentState,
        screen: isEnabled,
      };
    });
  };
  useEffect(() => {
    props.onMicClick(streamState.mic);
  }, [streamState.mic]);
  useEffect(() => {
    props.onVideoClick(streamState.video);
  }, [streamState.video]);
  return (
    <div className="meeting-footer">
      <div
        className={"meeting-icons " + (!streamState.mic ? "active" : "")}
        data-tip={streamState.mic ? "Mute Audio" : "Unmute Audio"}
        onClick={micClick}
      >
        <FontAwesomeIcon
          icon={!streamState.mic ? faMicrophoneSlash : faMicrophone}
          title="Mute"
        />
      </div>
      <div
        className={"meeting-icons " + (!streamState.video ? "active" : "")}
        data-tip={streamState.video ? "Hide Video" : "Show Video"}
        onClick={onVideoClick}
      >
        <FontAwesomeIcon icon={!streamState.video ? faVideoSlash : faVideo} />
      </div>
      {/* <div
        className="meeting-icons"
        data-tip="Share Screen"
        onClick={onScreenClick}
        disabled={streamState.screen}
      >
        <FontAwesomeIcon icon={faDesktop} />
      </div> */}

      <div
        className="meeting-icons"
        data-tip="Participants"
        onClick={props.handleShow}
      >
        <i className="fa fa-users" aria-hidden="true"></i>
      </div>
      <div className="other-icons">
        <ReactMediaRecorder
          screen
          render={({ status, startRecording, stopRecording, mediaBlobUrl }) => {
            return (
              <div className="d-flex">
                {/* <p>{status}</p> */}
                <button
                  className="meeting-icons"
                  data-tip="Record Video"
                  onClick={startRecording}
                >

                  <i className="fa-solid fa-record-vinyl"></i>
                </button>
                <button
                  className="meeting-icons"
                  data-tip="Stop Record "
                  onClick={stopRecording}
                >
                  {" "}
                  <i className="fa-solid fa-hand"></i>
                </button>

                {mediaBlobUrl && (
                  <a
                    href={mediaBlobUrl}
                    data-tip="Download video"
                    target="_blank"

                    download="My_File.mp4"
                    className="mx-2 meeting-icons"
                  >
                    <i className="fa-solid fa-download"></i>
                  </a>
                )}
                <div
                  className="meeting-icons"
                  data-tip="Leav Room"
                  style={{ backgroundColor: 'red' }}
                  // onClick={props.perticepents}
                  onClick={callDecline}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </div>

              </div>
            );
          }}
        />
      </div>

      <ReactTooltip />
    </div>
  );
};

export default MeetingFooter;
